const formatDate = (dateStr) => {
  if (!dateStr) return "-";

  const options = { day: "2-digit", month: "short", year: "numeric" };

  // Handle date ranges
  if (dateStr.includes("to")) {
    const [startRaw, endRaw] = dateStr.split("to");
    const start = startRaw.trim();
    const end = endRaw.trim();

    const startDate = new Date(start);
    const endDate = new Date(end);

    if (isNaN(startDate) || isNaN(endDate)) return dateStr; // fallback

    // If the two dates are the same, show only one
    if (startDate.getTime() === endDate.getTime()) {
      return startDate.toLocaleDateString("en-US", options);
    }

    return `${startDate.toLocaleDateString(
      "en-US",
      options
    )} - ${endDate.toLocaleDateString("en-US", options)}`;
  }

  // Single date
  const date = new Date(dateStr.trim());
  if (isNaN(date)) return dateStr; // fallback
  return date.toLocaleDateString("en-US", options);
};

export default formatDate;
